module.exports = __webpack_public_path__ + "img/58ne.5868069c.svg";